import { Suspense } from "react";
SuspenseComponent.propTypes = {
  children: PropTypes.any,
};
export default function SuspenseComponent({ children }) {
  return <Suspense fallback={<div />}>{children}</Suspense>;
}
